// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29A16","label":"styles_label__1qyf2"};